// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VAAb","questions":"styles_questions__1QL7i","footer":"styles_footer__279Eb"};